import { render, staticRenderFns } from "./DocumentsConfiguration.vue?vue&type=template&id=2f7db4f0"
import script from "./DocumentsConfiguration.vue?vue&type=script&lang=js"
export * from "./DocumentsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports